import React from 'react';
import { FaTimes } from 'react-icons/fa';

const QuestionPreview = ({ show, onHide, section }) => {
  if (!section || !show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onHide}>
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative bg-white dark:bg-dark-800 rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-6 border-b border-gray-100 dark:border-dark-700">
          <div className="flex items-center gap-3">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white">Preview: {section.sectionTitle}</h2>
            <span className="px-2.5 py-1 text-xs font-medium bg-gray-100 dark:bg-dark-700 text-gray-600 dark:text-gray-400 rounded-full">Form {section.formType}</span>
          </div>
          <button onClick={onHide} className="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-700"><FaTimes /></button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
          <div className="bg-gray-50 dark:bg-dark-700 rounded-xl overflow-hidden">
            <div className="p-4 border-b border-gray-200 dark:border-dark-600">
              <h5 className="font-semibold text-gray-900 dark:text-white">{section.sectionTitle}</h5>
              <p className="text-sm text-gray-500 dark:text-gray-400">{section.questions.length} questions • Order: {section.sectionOrder}</p>
            </div>
            <div className="p-4 space-y-4">
              {section.questions.sort((a, b) => a.order - b.order).map((question, index) => (
                <div key={index} className="p-4 bg-white dark:bg-dark-800 rounded-xl border border-gray-200 dark:border-dark-600">
                  <div className="flex justify-between items-start mb-3">
                    <div className="flex-1">
                      <p className="text-gray-900 dark:text-white"><span className="font-semibold text-primary-600">Q{index + 1}:</span> {question.text}</p>
                      {question.helpText && <p className="text-sm text-gray-500 mt-1 italic">Help: {question.helpText}</p>}
                    </div>
                    {question.isRequired && <span className="ml-2 px-2 py-0.5 text-xs font-medium bg-yellow-100 text-yellow-700 rounded">Required</span>}
                  </div>
                  <div className="flex gap-2">
                    <button type="button" className="px-3 py-1.5 text-sm font-medium text-green-600 border border-green-200 rounded-lg hover:bg-green-50">YES</button>
                    <button type="button" className="px-3 py-1.5 text-sm font-medium text-red-600 border border-red-200 rounded-lg hover:bg-red-50">NO</button>
                    <button type="button" className="px-3 py-1.5 text-sm font-medium text-yellow-600 border border-yellow-200 rounded-lg hover:bg-yellow-50">NA</button>
                    <button type="button" className="px-3 py-1.5 text-sm font-medium text-cyan-600 border border-cyan-200 rounded-lg hover:bg-cyan-50">COMMENT</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex justify-end p-6 border-t border-gray-100 dark:border-dark-700">
          <button onClick={onHide} className="px-4 py-2.5 text-gray-700 dark:text-gray-300 font-medium rounded-xl hover:bg-gray-100 dark:hover:bg-dark-700">Close</button>
        </div>
      </div>
    </div>
  );
};

export default QuestionPreview;